import CityPageTemplate from './CityPageTemplate';

export default function LakeMaryPage() {
  return (
    <CityPageTemplate
      city="Lake Mary"
      county="Seminole"
      slug="lake-mary"
      zipCodes={['32746', '32795']}
      neighborhoods={['Lake Mary Blvd Corridor', 'Heathrow', 'Country Club of Orlando', 'Timacuan', 'Colonial TownPark']}
      localContext="Home to the Heathrow business corridor and upscale communities like Timacuan, Lake Mary residents and professionals expect spotless spaces — and that's exactly what we deliver."
      metaDescription="Professional residential and commercial cleaning services in Lake Mary, FL. Serving ZIP codes 32746 & 32795. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
